var $b2166aefea3966d7$exports = {};
$b2166aefea3966d7$exports = {
    "help": `\u{41F}\u{43E}\u{43C}\u{43E}\u{449}`,
    "info": `\u{418}\u{43D}\u{444}\u{43E}\u{440}\u{43C}\u{430}\u{446}\u{438}\u{44F}`
};


export {$b2166aefea3966d7$exports as default};
//# sourceMappingURL=bg-BG.mjs.map
